// @react/hooks/useNotifications.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { notificationsStore } from '@core/stores';

/**
 * React hook for Notifications operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useNotifications } from '@react/hooks';
 *
 * const NotificationsList = observer(() => {
 *   const store = useNotifications();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useNotifications() {
  return notificationsStore;
}
